module.exports = __webpack_public_path__ + "static/media/IMG-10.60e0940d.jpg";